import { useState, useEffect, useRef } from "react";
import { Plus, Edit2, Trash2, Search, Star, Check, X, Loader2, ToggleLeft, ToggleRight, UtensilsCrossed, RefreshCw, AlertCircle, MapPin, Navigation } from "lucide-react";

const T = { primary:"#f97316",primaryDark:"#ea580c",primaryLight:"#fff7ed",primaryMid:"#fed7aa",white:"#ffffff",bg:"#f1f5f9",text:"#0f172a",textSub:"#64748b",textMuted:"#94a3b8",border:"#e2e8f0",green:"#16a34a",greenLight:"#dcfce7",red:"#ef4444",redLight:"#fef2f2",yellow:"#f59e0b" };
const API = "https://quickry-ivrv.onrender.com/api/restaurants";

// ✅ FIX: har call mein Authorization token bhejo
const getToken = () => localStorage.getItem("adminToken") || localStorage.getItem("token") || "";
const authHeaders = () => ({
  "Content-Type": "application/json",
  "Authorization": `Bearer ${getToken()}`,
});

const api = {
  get:    ()       => fetch(API, { headers: authHeaders() }).then(r=>r.json()),
  post:   (d)      => fetch(API, { method:"POST", headers:authHeaders(), body:JSON.stringify(d) }).then(r=>r.json()),
  put:    (id,d)   => fetch(`${API}/${id}`, { method:"PUT", headers:authHeaders(), body:JSON.stringify(d) }).then(r=>r.json()),
  delete: (id)     => fetch(`${API}/${id}`, { method:"DELETE", headers:authHeaders() }).then(r=>r.json()),
  toggle: (id)     => fetch(`${API}/${id}/toggle`, { method:"PATCH", headers:authHeaders() }).then(r=>r.json()),
};

const AKOLA_AREAS = [
  {name:"Civil Lines",lat:20.7068,lng:77.0072},{name:"Sindhi Camp",lat:20.7032,lng:77.0055},
  {name:"Ramdaspeth",lat:20.6998,lng:77.0112},{name:"Camp Area",lat:20.7015,lng:77.0090},
  {name:"Gorakshan Road",lat:20.7085,lng:77.0025},{name:"Jail Road",lat:20.7055,lng:77.0148},
  {name:"Station Road",lat:20.7042,lng:76.9998},{name:"City Center",lat:20.7002,lng:77.0082},
];

function MapPicker({lat,lng,onChange}) {
  const mapRef = useRef(null);
  const BOUNDS = {minLat:20.680,maxLat:20.730,minLng:76.990,maxLng:77.040};
  const toPixel = (la,lo) => ({
    x:Math.max(2,Math.min(98,((lo-BOUNDS.minLng)/(BOUNDS.maxLng-BOUNDS.minLng))*100)),
    y:Math.max(2,Math.min(98,((BOUNDS.maxLat-la)/(BOUNDS.maxLat-BOUNDS.minLat))*100))
  });
  const handleClick = (e) => {
    if(!mapRef.current) return;
    const r = mapRef.current.getBoundingClientRect();
    const xp=(e.clientX-r.left)/r.width, yp=(e.clientY-r.top)/r.height;
    onChange(
      parseFloat((BOUNDS.maxLat-yp*(BOUNDS.maxLat-BOUNDS.minLat)).toFixed(6)),
      parseFloat((BOUNDS.minLng+xp*(BOUNDS.maxLng-BOUNDS.minLng)).toFixed(6))
    );
  };
  const pos = toPixel(lat||20.7002,lng||77.0082);
  return (
    <div>
      <div ref={mapRef} onClick={handleClick} style={{position:"relative",width:"100%",height:200,background:"linear-gradient(135deg,#e8f5e9,#e3f2fd)",borderRadius:12,border:`2px solid ${T.border}`,cursor:"crosshair",overflow:"hidden"}}>
        {[20,40,60,80].map(p=><div key={`h${p}`} style={{position:"absolute",left:0,right:0,top:`${p}%`,height:1,background:"rgba(255,255,255,0.5)"}}/>)}
        {[20,40,60,80].map(p=><div key={`v${p}`} style={{position:"absolute",top:0,bottom:0,left:`${p}%`,width:1,background:"rgba(255,255,255,0.5)"}}/>)}
        {AKOLA_AREAS.map((a,i)=>{const p=toPixel(a.lat,a.lng);return(
          <div key={i} onClick={(e)=>{e.stopPropagation();onChange(a.lat,a.lng);}} title={a.name}
            style={{position:"absolute",left:`${p.x}%`,top:`${p.y}%`,transform:"translate(-50%,-50%)",width:8,height:8,borderRadius:"50%",background:"rgba(37,99,235,0.6)",cursor:"pointer",zIndex:2}}/>
        );})}
        <div style={{position:"absolute",left:`${pos.x}%`,top:`${pos.y}%`,transform:"translate(-50%,-100%)",zIndex:10}}>
          <svg width="28" height="36" viewBox="0 0 28 36"><path d="M14 0C6.268 0 0 6.268 0 14c0 9.333 14 22 14 22S28 23.333 28 14C28 6.268 21.732 0 14 0z" fill={T.primary}/><circle cx="14" cy="14" r="6" fill="white"/></svg>
        </div>
        <div style={{position:"absolute",top:8,left:8,background:"rgba(255,255,255,0.9)",borderRadius:6,padding:"3px 8px",fontSize:"0.65rem",fontWeight:700}}>📍 Akola Map — Click to pin</div>
        <div style={{position:"absolute",bottom:8,right:8,background:"rgba(0,0,0,0.65)",borderRadius:6,padding:"4px 9px",fontSize:"0.62rem",color:"#fff",fontFamily:"monospace"}}>{(lat||20.7002).toFixed(4)}, {(lng||77.0082).toFixed(4)}</div>
      </div>
      <div style={{marginTop:10}}>
        <div style={{fontSize:"0.68rem",fontWeight:700,color:T.textMuted,marginBottom:6}}>QUICK SELECT:</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
          {AKOLA_AREAS.map((a,i)=>(
            <button key={i} onClick={()=>onChange(a.lat,a.lng)}
              style={{background:(Math.abs((lat||0)-a.lat)<0.002&&Math.abs((lng||0)-a.lng)<0.002)?T.primary:T.bg,color:(Math.abs((lat||0)-a.lat)<0.002&&Math.abs((lng||0)-a.lng)<0.002)?"#fff":T.textSub,border:`1px solid ${T.border}`,borderRadius:8,padding:"4px 10px",fontSize:"0.72rem",fontWeight:600,cursor:"pointer",fontFamily:"inherit"}}>
              {a.name}
            </button>
          ))}
        </div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginTop:12}}>
        {[["Latitude",lat,"lat"],["Longitude",lng,"lng"]].map(([label,val,key])=>(
          <div key={key}>
            <div style={{fontSize:"0.68rem",fontWeight:700,color:T.textSub,marginBottom:4}}>{label}</div>
            <input type="number" step="0.0001" value={val||""} onChange={e=>{const v=parseFloat(e.target.value);if(!isNaN(v))key==="lat"?onChange(v,lng):onChange(lat,v);}}
              style={{width:"100%",border:`1.5px solid ${T.border}`,borderRadius:9,padding:"8px 11px",fontSize:"0.83rem",color:T.text,background:T.bg,outline:"none",fontFamily:"monospace"}}
              onFocus={e=>e.target.style.borderColor=T.primary} onBlur={e=>e.target.style.borderColor=T.border}/>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── EMPTY form defined OUTSIDE to prevent re-creation on every render ──
const EMPTY_FORM = {
  name:"", cuisine:"", area:"", phone:"", description:"",
  deliveryTime:30, deliveryFee:30, minOrder:99, offer:"",
  isPureVeg:false, isOpen:true, isPromoted:false,
  latitude:20.7002, longitude:77.0082,
  deliveryRadius:5,
  image:"", images:[],
};

function Modal({restaurant,onClose,onSave}) {
  const [form,setForm] = useState(restaurant
    ? { ...EMPTY_FORM, ...restaurant, cuisine:Array.isArray(restaurant.cuisine)?restaurant.cuisine.join(", "):restaurant.cuisine||"", images: restaurant.images||[] }
    : { ...EMPTY_FORM }
  );
  const [saving,setSaving] = useState(false);
  const [error,setError]   = useState("");
  const [tab,setTab]       = useState("info");
  const [newImg,setNewImg] = useState("");
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));

  const addImage = () => {
    const url = newImg.trim();
    if (!url) return;
    set("images", [...(form.images||[]), url]);
    setNewImg("");
  };
  const removeImage = (i) => {
    const arr = [...(form.images||[])];
    arr.splice(i,1);
    set("images", arr);
  };

  const handleSave=async()=>{
    if(!form.name.trim()||!form.area.trim()){setError("Name aur Area required!");setTab("info");return;}
    setSaving(true);setError("");
    try {
      const payload={
        ...form,
        cuisine:form.cuisine.split(",").map(c=>c.trim()).filter(Boolean),
        latitude:parseFloat(form.latitude),
        longitude:parseFloat(form.longitude),
        deliveryRadius:parseFloat(form.deliveryRadius)||5,
      };
      const res=restaurant?await api.put(restaurant._id,payload):await api.post(payload);
      if(res.success){onSave(res.data);}else{setError(res.message||"Error!");}
    } catch{setError("Backend connect nahi ho raha! localhost:5000 check karo");}
    setSaving(false);
  };

  const F=({label,k,type="text",placeholder="",span=1})=>(
    <div style={{gridColumn:`span ${span}`}}>
      <div style={{fontSize:"0.72rem",fontWeight:700,color:T.textSub,marginBottom:5}}>{label}</div>
      <input type={type} value={form[k]??""} placeholder={placeholder}
        onChange={e=>set(k,type==="number"?Number(e.target.value):e.target.value)}
        style={{width:"100%",border:`1.5px solid ${T.border}`,borderRadius:10,padding:"9px 12px",fontSize:"0.85rem",color:T.text,background:T.bg,outline:"none",fontFamily:"inherit",boxSizing:"border-box"}}
        onFocus={e=>e.target.style.borderColor=T.primary}
        onBlur={e=>e.target.style.borderColor=T.border}/>
    </div>
  );
  const Tog=({label,k})=>(
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"10px 0",borderBottom:`1px solid ${T.border}`}}>
      <span style={{fontSize:"0.85rem",fontWeight:600,color:T.text}}>{label}</span>
      <div onClick={()=>set(k,!form[k])} style={{cursor:"pointer",color:form[k]?T.primary:T.textMuted}}>
        {form[k]?<ToggleRight size={26}/>:<ToggleLeft size={26}/>}
      </div>
    </div>
  );
  return (
    <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.45)",zIndex:400,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div onClick={e=>e.stopPropagation()} style={{background:T.white,borderRadius:20,width:"100%",maxWidth:560,maxHeight:"92vh",overflowY:"auto",boxShadow:"0 24px 64px rgba(0,0,0,0.2)"}}>

        {/* Header */}
        <div style={{padding:"18px 20px",borderBottom:`1px solid ${T.border}`,display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,background:T.white,zIndex:1}}>
          <div style={{fontFamily:"'Fraunces',Georgia,serif",fontWeight:900,fontSize:"1.05rem"}}>{restaurant?"✏️ Edit Restaurant":"➕ Add New Restaurant"}</div>
          <button onClick={onClose} style={{background:T.bg,border:"none",borderRadius:"50%",width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}><X size={16} color={T.textSub}/></button>
        </div>

        {/* Tabs */}
        <div style={{display:"flex",borderBottom:`1px solid ${T.border}`}}>
          {[["info","📋 Basic Info"],["images","🖼️ Photos"],["location","📍 Location"]].map(([id,label])=>(
            <button key={id} onClick={()=>setTab(id)}
              style={{flex:1,background:"none",border:"none",borderBottom:`2.5px solid ${tab===id?T.primary:"transparent"}`,padding:"11px",fontWeight:tab===id?700:500,fontSize:"0.78rem",color:tab===id?T.primary:T.textSub,cursor:"pointer",fontFamily:"inherit"}}>
              {label}
            </button>
          ))}
        </div>

        <div style={{padding:"20px"}}>
          {error&&<div style={{background:T.redLight,border:`1px solid #fecaca`,borderRadius:10,padding:"10px 14px",marginBottom:14,display:"flex",alignItems:"center",gap:8}}><AlertCircle size={15} color={T.red}/><span style={{fontSize:"0.82rem",color:T.red,fontWeight:600}}>{error}</span></div>}

          {/* ── TAB: Basic Info ── */}
          {tab==="info"&&(
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
              <F label="Restaurant Name *" k="name" placeholder="e.g. Hotel Panchavati" span={2}/>
              <F label="Cuisine (comma separated)" k="cuisine" placeholder="North Indian, Chinese" span={2}/>
              <F label="Description" k="description" placeholder="Short description..." span={2}/>
              <F label="Area *" k="area" placeholder="Civil Lines, Akola"/>
              <F label="Phone" k="phone" placeholder="10-digit number"/>
              <F label="Delivery Time (min)" k="deliveryTime" type="number"/>
              <F label="Min Order (₹)" k="minOrder" type="number"/>
              <F label="Current Offer" k="offer" placeholder="20% off upto ₹100" span={2}/>
              <div style={{gridColumn:"span 2",border:`1px solid ${T.border}`,borderRadius:12,padding:"4px 14px"}}>
                <Tog label="Restaurant is Open"  k="isOpen"/>
                <Tog label="Pure Veg"            k="isPureVeg"/>
                <Tog label="Promoted (Featured)" k="isPromoted"/>
              </div>
            </div>
          )}

          {/* ── TAB: Photos / Images ── */}
          {tab==="images"&&(
            <div>
              <div style={{background:T.primaryLight,border:`1px solid ${T.primaryMid}`,borderRadius:12,padding:"12px 14px",marginBottom:16,fontSize:"0.78rem",color:T.primaryDark,lineHeight:1.6}}>
                🖼️ <strong>Add multiple photos</strong> — these will appear as a scrolling gallery on the restaurant page (Zomato style). First image is the main cover photo.
              </div>

              {/* Current images preview — scrollable */}
              {(form.images||[]).length > 0 && (
                <div style={{display:"flex",gap:10,overflowX:"auto",paddingBottom:10,marginBottom:14,scrollbarWidth:"none"}}>
                  {(form.images||[]).map((img,i)=>(
                    <div key={i} style={{flexShrink:0,position:"relative",width:120,height:90,borderRadius:12,overflow:"hidden",border:`2px solid ${i===0?T.primary:T.border}`}}>
                      <img src={img} alt={`photo ${i+1}`}
                        style={{width:"100%",height:"100%",objectFit:"cover"}}
                        onError={e=>{ e.target.style.display="none"; }}/>
                      {i===0&&<div style={{position:"absolute",top:4,left:4,background:T.primary,color:"#fff",fontSize:"0.55rem",fontWeight:700,padding:"2px 6px",borderRadius:4}}>COVER</div>}
                      <button onClick={()=>removeImage(i)}
                        style={{position:"absolute",top:4,right:4,background:"rgba(0,0,0,0.6)",border:"none",borderRadius:"50%",width:22,height:22,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
                        <X size={11} color="#fff"/>
                      </button>
                    </div>
                  ))}
                </div>
              )}

              {/* Add image URL */}
              <div style={{fontSize:"0.72rem",fontWeight:700,color:T.textSub,marginBottom:6}}>Add Photo URL</div>
              <div style={{display:"flex",gap:8}}>
                <input
                  value={newImg}
                  onChange={e=>setNewImg(e.target.value)}
                  onKeyDown={e=>e.key==="Enter"&&addImage()}
                  placeholder="https://example.com/restaurant-photo.jpg"
                  style={{flex:1,border:`1.5px solid ${T.border}`,borderRadius:10,padding:"9px 12px",fontSize:"0.85rem",color:T.text,background:T.bg,outline:"none",fontFamily:"inherit"}}
                  onFocus={e=>e.target.style.borderColor=T.primary}
                  onBlur={e=>e.target.style.borderColor=T.border}/>
                <button onClick={addImage}
                  style={{background:T.primary,border:"none",borderRadius:10,padding:"9px 16px",color:"#fff",fontWeight:700,fontSize:"0.82rem",cursor:"pointer",fontFamily:"inherit",flexShrink:0,display:"flex",alignItems:"center",gap:5}}>
                  <Plus size={14}/> Add
                </button>
              </div>
              <div style={{fontSize:"0.7rem",color:T.textMuted,marginTop:8}}>
                Tip: Press Enter to add quickly. Drag to reorder (coming soon).
              </div>

              {/* Single cover image fallback */}
              <div style={{marginTop:16,paddingTop:16,borderTop:`1px solid ${T.border}`}}>
                <div style={{fontSize:"0.72rem",fontWeight:700,color:T.textSub,marginBottom:6}}>Or single cover image URL</div>
                <input
                  value={form.image||""}
                  onChange={e=>set("image",e.target.value)}
                  placeholder="https://example.com/cover.jpg"
                  style={{width:"100%",border:`1.5px solid ${T.border}`,borderRadius:10,padding:"9px 12px",fontSize:"0.85rem",color:T.text,background:T.bg,outline:"none",fontFamily:"inherit",boxSizing:"border-box"}}
                  onFocus={e=>e.target.style.borderColor=T.primary}
                  onBlur={e=>e.target.style.borderColor=T.border}/>
              </div>
            </div>
          )}

          {/* ── TAB: Location ── */}
          {tab==="location"&&(
            <div>
              <div style={{background:T.primaryLight,border:`1px solid ${T.primaryMid}`,borderRadius:12,padding:"12px 14px",marginBottom:16,display:"flex",gap:10}}>
                <MapPin size={16} color={T.primary} style={{flexShrink:0,marginTop:1}}/>
                <div style={{fontSize:"0.78rem",color:T.primaryDark,lineHeight:1.6}}>
                  <strong>Click on map</strong> or select an area to set the exact location.<br/>
                  This helps customers find nearby restaurants and riders for navigation! 🛵
                </div>
              </div>
              <MapPicker lat={form.latitude} lng={form.longitude} onChange={(la,lo)=>{set("latitude",la);set("longitude",lo);}}/>

              {/* Delivery Radius */}
              <div style={{marginTop:16,background:T.bg,borderRadius:12,padding:"14px 16px"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                  <div style={{fontWeight:700,fontSize:"0.83rem",color:T.text}}>📦 Delivery Radius</div>
                  <div style={{background:T.primary,color:"#fff",fontWeight:800,fontSize:"0.85rem",padding:"3px 12px",borderRadius:100}}>{form.deliveryRadius||5} km</div>
                </div>
                <input
                  type="range"
                  min={1} max={20} step={0.5}
                  value={form.deliveryRadius||5}
                  onChange={e=>set("deliveryRadius",parseFloat(e.target.value))}
                  style={{width:"100%",accentColor:T.primary,cursor:"pointer"}}
                />
                <div style={{display:"flex",justifyContent:"space-between",fontSize:"0.65rem",color:T.textMuted,marginTop:4}}>
                  <span>1 km</span><span>5 km</span><span>10 km</span><span>20 km</span>
                </div>
                <div style={{fontSize:"0.72rem",color:T.textSub,marginTop:8}}>
                  Orders sirf is radius ke andar ke customers ko dikhenge.
                </div>
              </div>
              {form.latitude&&form.longitude&&(
                <div style={{marginTop:14,background:T.bg,borderRadius:10,padding:"11px 14px",display:"flex",alignItems:"center",gap:10}}>
                  <div style={{width:34,height:34,borderRadius:10,background:T.primaryLight,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}><Navigation size={16} color={T.primary}/></div>
                  <div>
                    <div style={{fontWeight:700,fontSize:"0.83rem",color:T.text}}>Location Set ✅</div>
                    <div style={{fontSize:"0.72rem",color:T.textSub,fontFamily:"monospace"}}>Lat: {form.latitude} · Lng: {form.longitude}</div>
                  </div>
                  <a href={`https://www.google.com/maps?q=${form.latitude},${form.longitude}`} target="_blank" rel="noreferrer"
                    style={{marginLeft:"auto",fontSize:"0.72rem",color:T.primary,fontWeight:700,textDecoration:"none"}}>Google Maps ↗</a>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Footer buttons */}
        <div style={{padding:"0 20px 20px",display:"flex",gap:10}}>
          <button onClick={onClose} style={{flex:1,background:T.bg,border:`1.5px solid ${T.border}`,borderRadius:12,padding:"12px",fontWeight:700,fontSize:"0.88rem",cursor:"pointer",color:T.textSub,fontFamily:"inherit"}}>Cancel</button>
          <button onClick={handleSave} disabled={saving}
            style={{flex:2,background:`linear-gradient(135deg,${T.primaryDark},${T.primary})`,border:"none",borderRadius:12,padding:"12px",fontWeight:800,fontSize:"0.88rem",cursor:"pointer",color:"#fff",fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"center",gap:7,boxShadow:"0 4px 14px rgba(249,115,22,0.3)"}}>
            {saving?<><Loader2 size={15} style={{animation:"spin .75s linear infinite"}}/>Saving...</>:<><Check size={15}/>{restaurant?"Update Restaurant":"Add Restaurant"}</>}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function Restaurants() {
  const [items,setItems]     = useState([]);
  const [loading,setLoading] = useState(true);
  const [error,setError]     = useState("");
  const [search,setSearch]   = useState("");
  const [modal,setModal]     = useState(null);
  const [delId,setDelId]     = useState(null);
  const [toast,setToast]     = useState("");

  const loadData=async()=>{
    setLoading(true);setError("");
    try{const res=await api.get();if(res.success)setItems(res.data);else setError(res.message);}
    catch{setError("Backend chal raha hai? localhost:5000 check karo!");}
    setLoading(false);
  };
  useEffect(()=>{loadData();},[]);
  const showToast=msg=>{setToast(msg);setTimeout(()=>setToast(""),2500);};

  const handleSave=(saved)=>{
    if(modal?._id)setItems(i=>i.map(r=>r._id===saved._id?saved:r));
    else setItems(i=>[saved,...i]);
    showToast(modal?._id?"Restaurant updated! ✅":"Restaurant MongoDB me save hua! ✅");
    setModal(null);
  };

  const handleDelete=async(id)=>{
    try{const res=await api.delete(id);if(res.success){setItems(i=>i.filter(r=>r._id!==id));showToast("Deleted!");}else showToast("Delete failed!");}
    catch{showToast("Server error!");}
    setDelId(null);
  };

  const handleToggle=async(id)=>{
    try{const res=await api.toggle(id);if(res.success)setItems(i=>i.map(r=>r._id===id?res.data:r));}
    catch{showToast("Toggle failed!");}
  };

  const filtered=items.filter(r=>!search||r.name.toLowerCase().includes(search.toLowerCase())||r.area?.toLowerCase().includes(search.toLowerCase()));

  return (
    <div>
      <style>{`@keyframes fadeUp{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}} @keyframes spin{to{transform:rotate(360deg)}}`}</style>
      {toast&&<div style={{position:"fixed",top:80,left:"50%",transform:"translateX(-50%)",background:T.text,color:"#fff",padding:"10px 20px",borderRadius:100,fontSize:"0.82rem",fontWeight:600,zIndex:500,display:"flex",alignItems:"center",gap:7,whiteSpace:"nowrap"}}><Check size={14} color={T.green}/>{toast}</div>}
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:20,flexWrap:"wrap",gap:12}}>
        <div>
          <div style={{fontFamily:"'Fraunces',Georgia,serif",fontWeight:900,fontSize:"1.1rem",color:T.text}}>{loading?"Loading...":`${items.length} Restaurants`}</div>
          <div style={{fontSize:"0.72rem",color:T.textMuted,marginTop:2}}>MongoDB se live data</div>
        </div>
        <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,background:T.white,border:`1.5px solid ${T.border}`,borderRadius:10,padding:"8px 12px"}}>
            <Search size={14} color={T.textMuted}/>
            <input placeholder="Search..." value={search} onChange={e=>setSearch(e.target.value)} style={{border:"none",background:"transparent",color:T.text,fontSize:"0.83rem",outline:"none",width:160,fontFamily:"inherit"}}/>
          </div>
          <button onClick={loadData} style={{background:T.bg,border:`1.5px solid ${T.border}`,borderRadius:10,padding:"9px 14px",cursor:"pointer",display:"flex",alignItems:"center",gap:5,color:T.textSub,fontFamily:"inherit"}}>
            <RefreshCw size={15} style={{animation:loading?"spin 1s linear infinite":"none"}}/>Refresh
          </button>
          <button onClick={()=>setModal("add")} style={{background:`linear-gradient(135deg,${T.primaryDark},${T.primary})`,border:"none",borderRadius:10,padding:"9px 18px",fontWeight:700,fontSize:"0.85rem",color:"#fff",cursor:"pointer",display:"flex",alignItems:"center",gap:6,fontFamily:"inherit",boxShadow:"0 4px 12px rgba(249,115,22,0.25)"}}>
            <Plus size={16}/>Add Restaurant
          </button>
        </div>
      </div>
      {error&&<div style={{background:T.redLight,border:`1px solid #fecaca`,borderRadius:12,padding:"13px 16px",marginBottom:16,display:"flex",alignItems:"center",gap:10}}><AlertCircle size={17} color={T.red}/><span style={{fontSize:"0.85rem",color:T.red,fontWeight:600}}>{error}</span><button onClick={loadData} style={{marginLeft:"auto",background:T.red,border:"none",borderRadius:8,padding:"5px 12px",color:"#fff",fontSize:"0.78rem",fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>Retry</button></div>}
      <div style={{background:T.white,borderRadius:16,border:`1px solid ${T.border}`,overflow:"hidden"}}>
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse",minWidth:750}}>
            <thead><tr style={{borderBottom:`1px solid ${T.border}`,background:T.bg}}>
              {["Restaurant","Area","Cuisine","Location","Rating","Delivery","Status","Actions"].map(h=>(
                <th key={h} style={{padding:"11px 14px",textAlign:"left",fontSize:"0.62rem",fontWeight:700,color:T.textMuted,textTransform:"uppercase",letterSpacing:"1px",whiteSpace:"nowrap"}}>{h}</th>
              ))}
            </tr></thead>
            <tbody>
              {filtered.map((r,i)=>(
                <tr key={r._id} style={{borderBottom:`1px solid ${T.border}`,animation:`fadeUp .3s ${i*.04}s ease both`,transition:"background .15s"}}
                  onMouseEnter={e=>e.currentTarget.style.background="#f8fafc"}
                  onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                  <td style={{padding:"13px 14px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:10}}>
                      <div style={{width:38,height:38,borderRadius:10,background:`linear-gradient(135deg,${T.primaryDark},${T.primary})`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}><UtensilsCrossed size={16} color="rgba(255,255,255,0.85)"/></div>
                      <div>
                        <div style={{fontWeight:700,fontSize:"0.87rem",color:T.text}}>{r.name}</div>
                        <div style={{display:"flex",gap:4,marginTop:2}}>
                          {r.isPromoted&&<span style={{background:T.primaryLight,color:T.primaryDark,fontSize:"0.6rem",fontWeight:700,padding:"1px 6px",borderRadius:100}}>Promoted</span>}
                          {r.isPureVeg&&<span style={{background:T.greenLight,color:T.green,fontSize:"0.6rem",fontWeight:700,padding:"1px 6px",borderRadius:100}}>Pure Veg</span>}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{padding:"13px 14px",fontSize:"0.8rem",color:T.textSub,whiteSpace:"nowrap"}}>{r.area}</td>
                  <td style={{padding:"13px 14px",fontSize:"0.75rem",color:T.textSub,maxWidth:130,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{Array.isArray(r.cuisine)?r.cuisine.join(", "):r.cuisine}</td>
                  <td style={{padding:"13px 14px"}}>
                    {r.latitude&&r.longitude?(
                      <a href={`https://www.google.com/maps?q=${r.latitude},${r.longitude}`} target="_blank" rel="noreferrer"
                        style={{display:"inline-flex",alignItems:"center",gap:5,background:T.primaryLight,color:T.primary,fontSize:"0.68rem",fontWeight:700,padding:"3px 9px",borderRadius:100,textDecoration:"none"}}>
                        <MapPin size={10}/>{r.latitude?.toFixed(3)},{r.longitude?.toFixed(3)}
                      </a>
                    ):<span style={{color:T.textMuted,fontSize:"0.72rem"}}>Not set</span>}
                  </td>
                  <td style={{padding:"13px 14px"}}><div style={{display:"flex",alignItems:"center",gap:4}}><Star size={13} fill={T.yellow} color={T.yellow}/><span style={{fontWeight:700,fontSize:"0.83rem"}}>{r.rating||"New"}</span></div></td>
                  <td style={{padding:"13px 14px",fontSize:"0.78rem",color:T.textSub,whiteSpace:"nowrap"}}>{r.deliveryTime} min · {r.deliveryFee===0?"Free":`₹${r.deliveryFee}`} · {r.deliveryRadius||5}km</td>
                  <td style={{padding:"13px 14px"}}>
                    <div onClick={()=>handleToggle(r._id)} style={{cursor:"pointer",display:"inline-flex",alignItems:"center",gap:5,background:r.isOpen?T.greenLight:T.redLight,color:r.isOpen?T.green:T.red,padding:"4px 10px",borderRadius:100,fontSize:"0.7rem",fontWeight:700}}>
                      <div style={{width:6,height:6,borderRadius:"50%",background:r.isOpen?T.green:T.red}}/>{r.isOpen?"Open":"Closed"}
                    </div>
                  </td>
                  <td style={{padding:"13px 14px"}}>
                    <div style={{display:"flex",gap:6}}>
                      <button onClick={()=>setModal(r)} style={{background:T.primaryLight,border:"none",borderRadius:8,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}><Edit2 size={14} color={T.primary}/></button>
                      <button onClick={()=>setDelId(r._id)} style={{background:T.redLight,border:"none",borderRadius:8,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}><Trash2 size={14} color={T.red}/></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {filtered.length===0&&!loading&&(
          <div style={{padding:"48px",textAlign:"center"}}>
            <UtensilsCrossed size={44} color={T.border} strokeWidth={1} style={{margin:"0 auto 12px",display:"block"}}/>
            <div style={{fontWeight:700,color:T.textSub}}>Koi restaurant nahi</div>
            <div style={{fontSize:"0.78rem",color:T.textMuted,marginTop:4}}>Pehla restaurant add karo! 🍽️</div>
          </div>
        )}
      </div>
      {modal&&<Modal restaurant={modal==="add"?null:modal} onClose={()=>setModal(null)} onSave={handleSave}/>}
      {delId&&(
        <div onClick={()=>setDelId(null)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.4)",zIndex:400,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div onClick={e=>e.stopPropagation()} style={{background:T.white,borderRadius:20,padding:"28px 24px",maxWidth:340,width:"100%",textAlign:"center"}}>
            <div style={{width:52,height:52,borderRadius:"50%",background:T.redLight,display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 16px"}}><Trash2 size={22} color={T.red}/></div>
            <div style={{fontFamily:"'Fraunces',Georgia,serif",fontWeight:900,fontSize:"1.1rem",marginBottom:8}}>Delete Restaurant?</div>
            <div style={{fontSize:"0.82rem",color:T.textSub,marginBottom:22}}>MongoDB se permanently remove ho jayega.</div>
            <div style={{display:"flex",gap:10}}>
              <button onClick={()=>setDelId(null)} style={{flex:1,background:T.bg,border:`1.5px solid ${T.border}`,borderRadius:12,padding:"11px",fontWeight:700,cursor:"pointer",fontFamily:"inherit",color:T.text}}>Cancel</button>
              <button onClick={()=>handleDelete(delId)} style={{flex:1,background:T.red,border:"none",borderRadius:12,padding:"11px",fontWeight:800,cursor:"pointer",color:"#fff",fontFamily:"inherit"}}>Delete</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}